var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Inject } from 'vue-property-decorator';
import { CalmComputedGetter } from "../../../lib/utils";
import classNames from "../../../lib/utils/classNames";
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import { CompNameTag } from './CompPathBreadcrumb';
let TriggersList = class TriggersList extends Vue {
  get triggers() {
    var _this$designer$pagele;
    return ((_this$designer$pagele = this.designer.pagelet) === null || _this$designer$pagele === void 0 ? void 0 : _this$designer$pagele.triggers) || [];
  }
  render() {
    const h = arguments[0];
    const {
      triggers
    } = this;
    return h("div", {
      "class": "ucd-toolbarPopMenu"
    }, [h("div", {
      "class": "ucd-toolbarPopMenu-item",
      "attrs": {
        "data-ucd-report-eid": "添加触发器"
      },
      "on": {
        "click": e => {
          this.designer.openCreateTriggerDialog({
            place: e.target
          });
        }
      }
    }, [h("i", {
      "class": "fa fa-plus",
      "style": "width:14px"
    }), "\xA0\u6DFB\u52A0\u89E6\u53D1\u5668"]), triggers.length !== 0 && h("hr", {
      "class": "ucd-toolbarPopMenu-rule"
    }), triggers.map((trigger, index) => h(CompNameTag, {
      "key": trigger.componentId || index,
      "class": "ucd-toolbarPopMenu-item",
      "attrs": {
        "compPath": `/@triggers/${index}`,
        "hideComponentId": true,
        "withActions": true
      }
    }))]);
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], TriggersList.prototype, "designer", void 0);
__decorate([Inject(INJECT_UICORE_BUS)], TriggersList.prototype, "uc", void 0);
TriggersList = __decorate([Component({
  name: 'TriggersList'
})], TriggersList);
export { TriggersList };
let TriggersToolbarWidget = class TriggersToolbarWidget extends Vue {
  get pagelet() {
    return this.designer.pagelet;
  }
  get triggerCount() {
    var _this$pagelet$trigger, _this$pagelet;
    return (_this$pagelet$trigger = (_this$pagelet = this.pagelet) === null || _this$pagelet === void 0 || (_this$pagelet = _this$pagelet.triggers) === null || _this$pagelet === void 0 ? void 0 : _this$pagelet.length) !== null && _this$pagelet$trigger !== void 0 ? _this$pagelet$trigger : 0;
  }
  render() {
    const h = arguments[0];
    const isCurrent = this.designer.compPath.startsWith('/@triggers/');
    return h("a-tooltip", {
      "attrs": {
        "placement": "bottomRight",
        "destroyTooltipOnHide": true
      }
    }, [h("button", {
      "attrs": {
        "type": "button"
      },
      "class": classNames('ucd-toolbar-button', {
        isCurrent
      })
    }, [this.triggerCount === 0 && '触发器', this.triggerCount !== 0 && h("span", [h("i", {
      "class": "fa fa-bolt",
      "attrs": {
        "aria-hidden": "true"
      }
    }), ` 触发器(${this.triggerCount})${isCurrent ? ' › ' : ''}`])]), h(TriggersList, {
      "slot": "title"
    })]);
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], TriggersToolbarWidget.prototype, "designer", void 0);
__decorate([CalmComputedGetter()], TriggersToolbarWidget.prototype, "triggerCount", null);
TriggersToolbarWidget = __decorate([Component({
  name: 'TriggersToolbarWidget'
})], TriggersToolbarWidget);
export default TriggersToolbarWidget;
//# sourceMappingURL=TriggersToolbarWidget.js.map
